<template>
  <Modal title="Параметры поиска" @backdrop-click="$emit('close')">
    <template slot="body">
      <div>
        <div class="modal__select form-group">
          <span class="select__subtitle form-group">Искомая сущность:</span>
          <Select
            class="select__input_criterion"
            :z-index="4000"
            :options="entitiesList"
            :default-key="defaultTableName"
            @input="setEntity"
          />
        </div>
        <TypeCriterion
          class="form-group"
          :default-key="defaultCriterion"
          @on-change="setCriterion"
        />
        <div v-if="withOperationTypes" class="modal__select">
          <div class="select__subtitle form-group">Тип операции:</div>
          <Select
            class="select__input_criterion"
            :z-index="2000"
            :options="operationTypes"
            :default-key="defaultOperationType"
            @input="setOperationType"
          />
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            type="button"
            class="btn btn-danger buttons__button_close-modal"
            :disabled="wasSubmitted"
            @click="$emit('close')"
          >
            Закрыть
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
import Select from "@/_shared/components/ui/Select";
import TypeCriterion from "@/_shared/features/search/TypeCriterion";
import { stockMovement } from "@/stock/constants";
export default {
  emits: [
    'close',
    'on-entity-type-select',
    'on-criterion-select',
    'on-operation-type-select',
  ],
  props: {
    entitiesList: {
      type: Object,
      required: true,
    },
    defaultCriterion: {
      type: String,
      default: 'name',
    },
    defaultTableName: {
      type: String,
      default: 'cloths',
    },
    defaultOperationType: {
      type: String,
      default: 'arrivals',
    },
    withOperationTypes: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Modal,
    Select,
    TypeCriterion,
  },
  data() {
    return {
      operationTypes: stockMovement.operationTypes,
    };
  },
  methods: {
    setOperationType(value) {
      this.$emit('on-operation-type-select', value);
    },
    setEntity(value) {
      this.$emit('on-entity-type-select', value);
    },
    setCriterion(value) {
      this.$emit('on-criterion-select', value);
    },
  },
};
</script>

<style scoped>
.modal__select {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/_shared/widgets/CriterionsModal.vue